import { Text } from '@loadsmart/loadsmart-ui'
import { ProgressBarCountdown, Layout } from '@loadsmart/miranda-react'
import { type ColorToken, toCSSValue } from '@loadsmart/miranda-react/dist/tokens'

import { type BulkRate } from '../domain/BulkRate'
import { isQuoteExpired } from '../domain/Quote'
import { type SpotQuote } from '../domain/SpotQuote'
import {
  calculateTimeLeftPercent,
  formatDeadlineText,
  formatRelativeSpotQuoteDeadline,
  getBidDeadlineBackgroundColor,
} from '../presenter/spotQuotePresenter'

export type BidDeadlineProps = {
  readonly spotQuote: SpotQuote | BulkRate
}

export function BidDeadline({ spotQuote }: BidDeadlineProps) {
  const { bidsDeadline } = spotQuote.quote
  const deadline = new Date(bidsDeadline)
  const isExpired = isQuoteExpired(spotQuote.quote)

  const { deadlineTimeText, sendRatesText } = formatDeadlineText({
    isExpired,
    bidsDeadline: deadline,
  })

  const formattedDeadline = formatRelativeSpotQuoteDeadline(isExpired, deadline)

  const timeLeftPercent = calculateTimeLeftPercent(spotQuote.createdAt, deadline)
  const backgroundColor: ColorToken = getBidDeadlineBackgroundColor(isExpired)

  return (
    <Layout.Group
      justify="space-between"
      padding="spacing-4"
      align="center"
      style={{
        background: toCSSValue(backgroundColor),
        borderTopLeftRadius: toCSSValue('spacing-1'),
        borderTopRightRadius: toCSSValue('spacing-1'),
        display: 'flex',
      }}
    >
      <Text>
        {isExpired ? (
          <>
            <Text variant="body-bold" color={'color-danger-dark'}>
              {deadlineTimeText}{' '}
            </Text>
            <Text color={'color-danger-dark'}>{sendRatesText}</Text>
          </>
        ) : (
          <>
            {deadlineTimeText} <Text variant="body-bold">{formattedDeadline}</Text>
          </>
        )}
      </Text>
      <div style={{ flexGrow: 1 }}>
        <ProgressBarCountdown value={timeLeftPercent} style={{ width: '100%' }} />
      </div>
    </Layout.Group>
  )
}
